import React from 'react';
import { ThemeProvider } from '@material-ui/styles';
import { createTheme, responsiveFontSizes } from '@material-ui/core';

import Header from './components/Header';
import Footer from './components/Footer';
import Main from './components/Main';

import DateFnsUtils from '@date-io/date-fns';
import svLocale from 'date-fns/locale/sv';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

let theme = createTheme({
    palette: {
        primary: {
            main: '#7F35B2',
        },
        secondary: {
            main: '#C7C6CB',
        },
        error: {
            main: '#DB1829',
        },
        text: {
            // secondary: "#d8d8d8",
            hint: '#d8d8d8',
        },
    },
    shape: {
        borderRadius: 0,
    },
    typography: {
        button: {
            textTransform: 'none'
        }
    }
});
theme = responsiveFontSizes(theme);

const App = () => {


    return (
        <ThemeProvider theme={theme}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={svLocale}>
                <Header />
                <Main />
                <Footer />
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    );
};
export default App;
